import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="container">
      <div className="card checkout-panel">
        <h1>Page not found</h1>
        <p className="muted">That route is not on the playbook.</p>
        <Link className="btn btn-primary" to="/">
          Back home
        </Link>
      </div>
    </div>
  );
}
